// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Breadcrumbs, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface DetailPageHeaderProps {
  parentBreadcrumb: ReactNode;
  currentBreadcrumb: ReactNode;
  title: ReactNode;
  /**
   * Render the title as-is instead of wrapping it in the standard `h5`
   * Typography, for titles that provide their own typography (e.g. an
   * editable title button)
   */
  disableTitleTypography?: boolean;
  titleAdornment?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
}

export function DetailPageHeader(props: DetailPageHeaderProps) {
  return (
    <>
      <Stack marginTop={3} paddingX={3}>
        <Breadcrumbs separator="›">
          {props.parentBreadcrumb}
          <Typography variant="body2" color="text.secondary">
            {props.currentBreadcrumb}
          </Typography>
        </Breadcrumbs>
      </Stack>

      <Stack paddingX={{ xs: 1, md: 3 }} spacing={1} marginTop={2}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            {props.disableTitleTypography ? (
              props.title
            ) : (
              <Typography variant="h5">{props.title}</Typography>
            )}
            {props.titleAdornment}
          </Stack>
          {props.actions}
        </Stack>
        {props.children}
      </Stack>
    </>
  );
}
